/**用户班级模块 */
import request from '../request/http';
/**新增班级 */
export function AddClass(data){
    return request({
        url: '/sp/userClass/add',
        method: 'post',
        data
    })
}
/**删除班级 */
export function DelClass(data){
    return request({
        url: '/sp/userClass/del',
        method: 'post',
        data
    })
}
/**修改班级 */
export function UpdateClass(data){
    return request({
        url: '/sp/userClass/update',
        method: 'post',
        data
    })
}
/**分页查询班级信息 */
export function ClassPageList(data){
    return request({
        url: '/sp/userClass/pageList',
        method: 'post',
        data
    })
}
/**查询班级列表 */
export function GetClassList(data){
    return request({
        url: '/sp/userClass/getClassList',
        method: 'post',
        data
    })
}
/**绑定用户 */
export function BindUser(data){
    return request({
        url: '/sp/userClass/bindUser',
        method: 'post',
        data
    })
}
/**解绑用户 */
export function CancelClassBindUser(data){
    return request({
        url: '/sp/userClass/cancelClassBindUser',
        method: 'post',
        data
    })
}
/**分页查询班级可绑定用户 */
export function PageQueryClassBindUser(data){
    return request({
        url: '/sp/userClass/pageQueryClassBindUser',
        method: 'post',
        data
    })
}
/**班级成绩排名(实训分数) */
export function GetClassTrainingRanking(data){
    return request({
        url: '/sp/learningAnalysis/getClassTrainingRanking',
        method: 'post',
        data
    })
}